import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import ApplicantForm from "../Forms/spect/ApplicationForm";
import { validateField } from "../../utils/validation/validation";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import {Row, Button} from "react-bootstrap";
import InputField from "../../utils/InputField";
import TextAreaField from "../../utils/TextAreaField";
import { updateApplication } from "../../services/spect-api";
import { useToast } from '../../contexts/ToastContext';
import { useLoading } from "../../contexts/LoadingContext";
import { formatDate } from "../../utils/TableUtils";


function SpectApplicationModal({ show, onHide, data }) {
  const { showToast } = useToast();
  const { startLoading, stopLoading } = useLoading();
  const initialFormValue = {
    applicant: {
      role: data?.role || "",
      issuedPermitNumber: data?.issuedPermitNumber || "",
      name: data?.name || "",
      address: data?.address || "",
      phoneNumber: data?.phoneNumber || "",
      requestedInspection: data?.requestedInspection || "",
      email: data?.email || "",
      communityEmailAddress: data?.communityEmailAddress || "",
      comments: data?.comments || "",
      files: data?.files || [],
      fileLinks: data?.fileLinks || "",
      createdAt: formatDate(data?.createdAt) || "",
      updatedAt: formatDate(data?.updatedAt) || "",
    },
    app: {
       status: data?.status || "Pending",
       reason: data?.reason || "",
    }
   
  };
  const [formData, setFormData] = useState(initialFormValue);
  const [errors, setErrors] = useState({
    applicant: {}
  });
  const handleDataChange = (section, field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [section]: { ...prevData[section], [field]: value },
    }));
  };
  const handleValidate = (section, field, error) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [section]: { ...prevErrors[section], [field]: error },
    }));
  };

  const validateEntireForm = () => {
    const applicantErrors = {};

    let isValid = true;

    Object.entries(formData.applicant).forEach(([field, value]) => {
      const error = validateField(field, value);
      if (error) {
        applicantErrors[field] = error;
        isValid = false;
      }
    });
    setErrors({ applicant: applicantErrors });
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateEntireForm();
    if (!isValid) return;
    try {
      startLoading();
      const combinedData = {
        ...formData.applicant,
        ...formData.app,
      };
      await updateApplication(data.id, combinedData);
      showToast('Update successfully!', 'success');
      onHide();
    } catch (error) {
      showToast(error.message || "Update failed. Please try again.", 'error');
    } finally {
      stopLoading();
    }
  };


  const applicationStatus = data ? data.status : "Pending";
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="add-community-modal"
      className="add-community-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-uppercase" id="add-community-modal">
          Edit Application
        </Modal.Title>
        {data && (
          <div
            className={`modal-header-status status-${applicationStatus.toLowerCase()}`}
          >
            Status:{" "}
            <span className={`span-${applicationStatus.toLowerCase()}`}>
              {applicationStatus}
            </span>
          </div>
        )}
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <div className="form-wrapper mb-5 form-modal">
            <Row>
              {data && (
                <Col md="4">
                  <Row className="mb-3">
                    <InputField
                      field="status"
                      label="Status"
                      value={formData.app.status}
                      onChange={(field, value) =>
                        handleDataChange("app", field, value)
                      }
                      error={errors.status}
                      type="select"
                      options={["Pending", "Approved", "Rejected"]}
                      as={Col}
                      controlId="applicantStatus"
                    />
                  </Row>
                  <Row className="mb-3">
                    <TextAreaField
                      field="reason"
                      label="Reason"
                      value={formData.app.reason}
                      onChange={(field, value) =>
                        handleDataChange("app", field, value)
                      }
                      error={errors.reason}
                      as={Col}
                      controlId="applicantReason"
                    />
                  </Row>
                </Col>
              )}
              <Col md="8">
              <ApplicantForm
                      data={formData.applicant}
                      onChange={(field, value) =>
                        handleDataChange("applicant", field, value)
                      }
                      onValidate={(field, error) =>
                        handleValidate("applicant", field, error)
                      }
                      errors={errors.applicant || {}}
                      isFrom={"modal"}
                    />
              </Col>
            </Row>
          </div>
          <div className="text-end">
            <Button type="submit" className="btn btn-submit">
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default SpectApplicationModal;
